import React, { useEffect, useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh }) => {
  console.log(data, "data")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [tempTags, setTempTags] = useState(data.tags || []); // Temporary tag state
  const [category, setCategory] = useState([])
   const [isApp, setIsApp] = useState(data?.app);
   const [description,setDescription] = useState(data.description)

  useEffect(() => {
    if (data?.app !== undefined) {
      setIsApp(Boolean(data.app)); // Ensure it's a boolean
    }
  }, [data]);
  const getCategories = async () => {
    const { response } = await AppService.medialibrarycategory.get({
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
    // setLoader(false)
  }
  useEffect(() => {
    getCategories()
  }, [])


  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && event.target.value.trim() !== '') {
      setTempTags([...tempTags, event.target.value.trim()]); // Update tempTags instead of tags
      event.target.value = '';
    }
  };

  const handleRemoveTempTag = (index) => {
    setTempTags(tempTags.filter((_, i) => i !== index)); // Modify tempTags instead of tags
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    const payload = {
      name: e.target.name.value,
      description,
      video_path: e.target.video_path.value,
      transcription: e.target.transcription.value,
      type: e.target.type.value,
      app: isApp,
      priority: Number(e.target.priority.value),
      tags: tempTags, // Save tempTags when submitting
      category: e.target.category.value,
    };

    console.log(payload, "payload");

    const { response } = await AppService.medialibrary.update({
      query: `id=${data._id}`,
      payload,
    });

    if (response) {
      handleRefresh();
      setProcessing(false);
      setOpenEditProduct(false);
      setTags(tempTags); // Update tags state after successful save
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Tag
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
               <Editor handleChange={setDescription} data={description}/>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Transcription</MDTypography>
              <MDInput label="Transcription" name="transcription" fullWidth required defaultValue={data.transcription} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data.type}
              >
                <option value="location">Location</option>
                <option value="agency">Agency</option>
                <option value="levelupmarketplace">levelupmarketplace</option>
              </MDInput>
            </MDBox>

             <MDBox mb={2}>
               <MDTypography variant="button">App</MDTypography>
                    <div>
                    <FormControl component="fieldset">
                 <RadioGroup
                   row
                   name="app"
                   value={isApp} 
                   onChange={(e) => setIsApp(e.target.value === "true")}
                 >
                   <FormControlLabel value="true" control={<Radio />} label="True" />
                   <FormControlLabel value="false" control={<Radio />} label="False" />
                 </RadioGroup>
               </FormControl>
                    </div>
                         </MDBox>




            <MDBox mb={2}>
              <MDTypography variant="button">Video Path</MDTypography>
              <MDInput label="Video Path" name="video_path" fullWidth required defaultValue={data.video_path} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Priority Number</MDTypography>
              <MDInput
                label="Priority"
                name="priority"
                type="number"
                fullWidth
                required
                inputProps={{ min: 1 }}
                defaultValue={data.priority}

              />
            </MDBox>

            {/* New Tags Field */}
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Tags</MDTypography>
              <MDInput
                label="Add tags (press Enter)"
                onKeyPress={handleKeyPress}
                fullWidth
              />
              <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                {tags.map((tag, index) => (
                  <MDBox
                    key={index}
                    bgcolor="grey.200"
                    px={1}
                    borderRadius="5px"
                    display="flex"
                    alignItems="center"
                  >
                    <MDTypography variant="caption" color="info">{tag}</MDTypography>
                    <MDTypography
                      variant="caption"
                      onClick={() => setTags(tags.filter((_, i) => i !== index))}
                      style={{ cursor: 'pointer', marginLeft: '4px' }}
                    >
                      ×
                    </MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Tags</MDTypography>
              <MDInput
                label="Add tags (press Enter)"
                onKeyPress={handleKeyPress}
                fullWidth
              />
              <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                {tempTags.map((tag, index) => (
                  <MDBox
                    key={index}
                    bgcolor="grey.200"
                    px={1}
                    borderRadius="5px"
                    display="flex"
                    alignItems="center"
                  >
                    <MDTypography variant="caption" color="info">{tag}</MDTypography>
                    <MDTypography
                      variant="caption"
                      onClick={() => handleRemoveTempTag(index)}
                      style={{ cursor: 'pointer', marginLeft: '4px' }}
                    >
                      ×
                    </MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="category"
                fullWidth
                required
                defaultValue={data?.category?._id || ""}
                SelectProps={{ native: true }}
              >
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
